import styled, { css } from 'styled-components';

import { Table as UITable, mediaQuery } from '@catalyze/ui';

export const TableCard = styled.div`
    border-radius: 0.5rem;
    background: #fff;
    margin: 1.5rem 0 0 0;
    border: 1px solid rgba(0, 0, 0, 0.05);
    ${mediaQuery(
        2,
        css`
            margin: 1.5rem 2.5rem 3rem 2.5rem;
            margin-top: 2rem;
        `
    )}
`;

export const StyledHeader = styled.div`
    text-align: right;
`;

export const StyledTextWrapper = styled.div`
    margin-right: 35px;
`;

export const StyledTable = styled(UITable)`
    margin: 0;
` as unknown as typeof UITable;
